/**
 * The Lilia menu's open state, shared by its ways in (navigation handoff §2):
 * the L button opens it on pinned and recent; ⌘K, or the bar's search field,
 * opens the same panel already typing.
 */
import { useSyncExternalStore } from "react";

export type LiliaMenuMode = "browse" | "search";
interface State { open: boolean; mode: LiliaMenuMode }

let state: State = { open: false, mode: "browse" };
/** The address the menu was opened at. */
let openedAt: string | null = null;
const listeners = new Set<() => void>();
const set = (next: State) => {
  if (next.open && !state.open) openedAt = window.location.pathname;
  if (next.open === state.open && next.mode === state.mode) return;
  state = next;
  listeners.forEach((l) => l());
};

export const liliaMenu = {
  /** Moving to another address closes the menu. Compared with where it was
   *  opened, not with the last address a bar saw: a bar that mounts late (the
   *  editor's, after its code loads) must not shut a menu opened since. */
  pathChanged: (path: string) => {
    if (state.open && openedAt !== null && openedAt !== path) set({ ...state, open: false });
  },
  show: (mode: LiliaMenuMode = "browse") => set({ open: true, mode }),
  hide: () => set({ ...state, open: false }),
  toggle: (mode: LiliaMenuMode = "browse") => set(state.open ? { ...state, open: false } : { open: true, mode }),
};

export function useLiliaMenu(): State {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => listeners.delete(l); },
    () => state,
  );
}
